import { useState } from "react";
import { ScrollView, type ScrollViewProps, XStack } from "tamagui";
import { hairline } from "../utils/hairline";
import { Paragraph2 } from "./Typography";
interface Tab {
  id: string;
  name: string;
}
export type SelectBarTabs = Tab[];
type ScrollViewContainerStyle = Exclude<ScrollViewProps["contentContainerStyle"], "unset" | undefined>;
interface HorizontalSelectBarProps {
  initialTabIndex?: number;
  tabs: SelectBarTabs;
  onTabPress: (id: string) => void;
  scrollViewContainerProps?: ScrollViewContainerStyle;
  children?: React.ReactNode;
}
export const HorizontalSelectBar = ({
  initialTabIndex = 0,
  tabs,
  onTabPress,
  scrollViewContainerProps,
  children
}: HorizontalSelectBarProps) => {
  const [activeTab, setActiveTabLocal] = useState(initialTabIndex);
  const setActiveTab = (index: number, id: string) => {
    setActiveTabLocal(index);
    onTabPress(id);
  };
  return <XStack pt="$2" px="$3.5" width="100%" backgroundColor="$background" borderBottomWidth={hairline} borderColor="$borderColor" $platform-web={{
    borderColor: "$strokeSecondary",
    height: "$4",
    borderBottomWidth: 1
  }} justifyContent="space-between" alignItems="center" data-sentry-element="XStack" data-sentry-component="HorizontalSelectBar" data-sentry-source-file="HorizontalSelectBar.tsx">
      <ScrollView horizontal flex={1} showsHorizontalScrollIndicator={false} contentContainerStyle={{
      flex: 1,
      alignItems: "center",
      justifyContent: "flex-start",
      ...scrollViewContainerProps
    }} data-sentry-element="ScrollView" data-sentry-source-file="HorizontalSelectBar.tsx">
        {tabs.map((tab, index) => <TabComponent key={tab.id} tab={tab} isActive={index === activeTab} setActiveTab={() => setActiveTab(index, tab.id)} />)}
      </ScrollView>
      {children}
    </XStack>;
};
const TabComponent = ({
  tab,
  isActive,
  setActiveTab
}: {
  tab: Tab;
  isActive: boolean;
  setActiveTab: () => void;
}) => {
  return <XStack cursor="pointer" key={tab.id} onPress={setActiveTab} justifyContent="center" alignItems="center" height={35} paddingHorizontal="$4" transition="200ms" theme="alt2" borderBottomWidth="$1" backgroundColor="transparent" borderBottomColor={isActive ? "$color" : "$background"} data-sentry-element="XStack" data-sentry-component="TabComponent" data-sentry-source-file="HorizontalSelectBar.tsx">
      <Paragraph2 transition="200ms" color={isActive ? "$color" : "$textSecondary"} zIndex={20} bold data-sentry-element="Paragraph2" data-sentry-source-file="HorizontalSelectBar.tsx">
        {tab.name}
      </Paragraph2>
    </XStack>;
};